import { Component, EventEmitter, Output } from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { MatDialog } from "@angular/material/dialog";
import { ApiserviceService } from "../../../../../../src/app/apiservice.service";
import { ConfirmDialogBox } from "../../../confirm-dialog/confirm-dialogbox";

@Component({
  selector: "app-city-reordering",
  templateUrl: "./city-reordering.component.html",
  styleUrls: ["./city-reordering.component.scss"],
})
export class CityReorderingComponent {
  @Output() loader = new EventEmitter<boolean>();
  isTableVisible = false;
  displayColumn = ["dragdrop", "city_order", "city_name", "process_count"];
  originalData: any[] = [];
  selectedData: any[] = [];
  constructor(
    private apiService: ApiserviceService,
    private dialog: MatDialog
  ) {}
  toggleTable() {
    this.isTableVisible = !this.isTableVisible;
    if (this.isTableVisible) {
      this.loadCities();
    }
  }
  loadCities() {
    const apiUrl = "common-spark-process/cities";
    this.loader.emit(true)
    this.apiService.getGesData(apiUrl, "253").subscribe({
      next: (response: any) => {
        this.loader.emit(false)
        if (response?.status == 200 && response.data) {
          // Map API data directly to our structure
          this.selectedData = response.data.map((item: any) => ({
            id: item.id,
            city_name: item.city_name, // Use API's city name directly
            city_order: item.city_order,
            process_count: item.process_count,
          }));
        }
      },
      error: (error) => {
      this.loader.emit(false)
      },
    });
  }

  onDrop(event: CdkDragDrop<any[]>) {
    const dataCopy = [...this.selectedData];
    moveItemInArray(dataCopy, event.previousIndex, event.currentIndex);
    const updatedData = dataCopy.map((item, index) => ({
      ...item,
      city_order: index + 1,
    }));

    const dialogRef = this.dialog.open(ConfirmDialogBox, {
      data: {
        message: "Are you sure you want to update sync order?",
        parent_data: {
          confirmDialogYes: (confirmed: boolean) => {
            if (confirmed) {
              this.selectedData = updatedData;
              this.updateCities();
            }
          },
        },
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined) {
        this.selectedData = [...this.originalData];
      }
    });
  }
  // city-reordering.component.ts
  updateCities() {

    const apiUrl = "common-spark-process/cities";
    let payload = {
      city_order_list: this.selectedData.map((item) => ({
        id: item.id,
        city_order: item.city_order,
        process_count: item.process_count,
        city_id: item.city_id,
        city_name: item.city_name,
      })),
    };
     this.loader.emit(true)
    this.apiService.patchGesData(apiUrl, payload, "253").subscribe({
      next: (response: any) => {
         this.loader.emit(false)
        if (response?.status == 201) {
          this.loadCities(); // Refresh data
        }
        
      },
      error: (error) => {
       this.loader.emit(false)

      },
    });
  }
}
